// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TerminologyLibraryResponseItemsInner } from './terminology-library-response-items-inner';
import {
    TerminologyLibraryResponseItemsInnerFromJSON,
    TerminologyLibraryResponseItemsInnerFromJSONTyped,
    TerminologyLibraryResponseItemsInnerToJSON,
    TerminologyLibraryResponseItemsInnerToJSONTyped,
} from './terminology-library-response-items-inner';

/**
 * 
 * @export
 * @interface TerminologyLibraryResponse
 */
export interface TerminologyLibraryResponse {
    /**
     * 
     * @type {Array<TerminologyLibraryResponseItemsInner>}
     * @memberof TerminologyLibraryResponse
     */
    items?: Array<TerminologyLibraryResponseItemsInner>;
    /**
     * 
     * @type {number}
     * @memberof TerminologyLibraryResponse
     */
    limit?: number;
    /**
     * 
     * @type {number}
     * @memberof TerminologyLibraryResponse
     */
    offset?: number;
    /**
     * 
     * @type {number}
     * @memberof TerminologyLibraryResponse
     */
    total?: number;
    /**
     * 
     * @type {string}
     * @memberof TerminologyLibraryResponse
     */
    version?: string;
}

/**
 * Check if a given object implements the TerminologyLibraryResponse interface.
 */
export function instanceOfTerminologyLibraryResponse(value: object): value is TerminologyLibraryResponse {
    return true;
}

export function TerminologyLibraryResponseFromJSON(json: any): TerminologyLibraryResponse {
    return TerminologyLibraryResponseFromJSONTyped(json, false);
}

export function TerminologyLibraryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TerminologyLibraryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'items': json['items'] == null ? undefined : ((json['items'] as Array<any>).map(TerminologyLibraryResponseItemsInnerFromJSON)),
        'limit': json['limit'] == null ? undefined : json['limit'],
        'offset': json['offset'] == null ? undefined : json['offset'],
        'total': json['total'] == null ? undefined : json['total'],
        'version': json['version'] == null ? undefined : json['version'],
    };
}

export function TerminologyLibraryResponseToJSON(json: any): TerminologyLibraryResponse {
    return TerminologyLibraryResponseToJSONTyped(json, false);
}

export function TerminologyLibraryResponseToJSONTyped(value?: TerminologyLibraryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': value['items'] == null ? undefined : ((value['items'] as Array<any>).map(TerminologyLibraryResponseItemsInnerToJSON)),
        'limit': value['limit'],
        'offset': value['offset'],
        'total': value['total'],
        'version': value['version'],
    };
}
